import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { InvoiceNegativeBalance } from 'src/app/shared/entities/InvoiceNegativeBalance';



@Component({
  selector: 'app-confirm-submit-payment',
  templateUrl: './confirm-submit-payment.component.html',
  styleUrls: ['./confirm-submit-payment.component.scss']
})
export class ConfirmSubmitPaymentComponent implements OnInit {
  //invoiceList: Array<any> = [];
  invoiceNumber: string = '';
  invoiceToDisplay: string = '';
  pendingInvoiceList: InvoiceNegativeBalance[] = [];
  totalNumberOfPayments: number = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public invoiceData: InvoiceNegativeBalance[]) { 

    let jsonInvoiceDate = JSON.stringify(invoiceData);
    let invoiceString = jsonInvoiceDate.replace('{"invoiceList":','');
    invoiceString = invoiceString.replace(']}',']');

    
    
    this.pendingInvoiceList = JSON.parse(invoiceString);
    
    this.totalNumberOfPayments = this.pendingInvoiceList[0].totalPaymentNumber;

  }

  ngOnInit(): void {
  } 

}
 